export enum ToolboxColor {
  White = 'white',
  Grey = 'grey',
  Primary = 'primary'
}
